import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import Home from "./Home";
import Home from "./crm/Home/Home";
import Session from "react-session-api";
// import Dashboard from "../components/dashboard/Dashboard";
import PrimaryMaster from "./masters/primarymaster/PrimaryMaster";
import CreateProductMaster from "./masters/primarymaster/CreateProductMaster";
import CreateSymptomMaster from "./masters/primarymaster/CreateSymptomMaster";
import BranchMaster from "./masters/BranchMaster";
// import ServiceCenter from "./masters/servicecenter/ServiceCenter";
// import ServiceCenterView from "./masters/servicecenter/ServiceCenterView";
import TravelRequestReport from "./crm/Reports/TravelRequestReport";
import EmployeeMaster from "./masters/Employeemaster/EmployeeMaster";
import ExpenseSheetList from "./ExpenseSheet/ExpenseSheetList";
import ExpenseClaimedReport from "./crm/Reports/ExpenseClaimedReport";
import UserMaster from "./masters/usermaster/UserMaster";
import TravelRequestApproval from "./Approvels/TravelRequestApproval";
import ExpenseApproval from "./Approvels/ExpenseApproval";
import TravelRequest from "./TravelRequest/TravelRequest";
import PendingManagerApproval from "./Approvels/PendingManagerApproval";
import ExpenseReport from "./crm/Reports/ExpenseReport";
import SeniorAccountReport from "./crm/Reports/SeniorAccountReport";
import SeniorExpenseApproval from "./Approvels/SeniorExpenseApproval";
import SeniorExpenseReport from "./crm/Reports/SeniorExpenseReport";
//import ServiceCenter from "./masters/ServiceCenter";
// import Account from "./masters/accounts/Account";
// import DashboardBA from "./crm/DashboardBA/DashboardBA";
// import DashboardIS from "./crm/DashboardIS/DashboardIS";
// import DashboardSales from "./crm/DashboardSales/DashboardSales";
// import DashboardPreSales from "./crm/DashboardPreSales/DashboardPreSales";
// import ImportDataPoints from "./crm/ImportDataPoints/ImportDataPoints";
// import AssignLeadToSalesExecutive from "./crm/AssignLeadToSalesExecutive/AssignLeadToSalesExecutive";
// import AllocateDatapointsFromNurtureBasketToISR from "./crm/AllocateDatapointsFromNurtureBasketToISR/NurtureBasket";
// import MyOpportunities from "./crm/MyOpportunities/MyOpportunities";
// import MyCustomer from "./crm/MyCustomer/MyCustomer";
// import DocTestListMaster from "./masters/DocTestListMaster/DocTestListMaster";
//import Account from "./crm/accounts/Account";
//import AccountView from "./crm/accounts/AccountView";
// import AllocateLeadsToISR from "./crm/AllocateLeadsToISR/AllocateLeadsToIRS";
// import BonusManagment from "./Adminstrator/BonusManagment/BonusManagment";
// import Customer from "./Adminstrator/Customer/Customer";
// import MilestoneTemplates from "./Adminstrator/MilestoneTemplates/MilestoneTemplates";
// import ProductMasterSKU from "./Adminstrator/ProductMaster(SKU Master)/ProductMasterSKU";
// import PrimaryMasterAdministrator from "./Adminstrator/PrimaryMastersAdministrator/PrimaryMasterAdministrator";
// import IncentiveManagment from "./Adminstrator/IncentiveManagment/IncentiveManagment";
// import Vendors from "./Adminstrator/Vendors/Vendors";
// import UserMasterAndRight from "./Adminstrator/UserMaster&UserRights/UserMaster&Rights";
// import SalesTarget from "./Adminstrator/SalesTarget/SalesTarget";
// import Partners from "./Adminstrator/Partners/Partners";
// import PriceList from "./Adminstrator/PriceList/PriceList";
// import RenewalTarget from "./Adminstrator/RenewalTarget/RenewalTarget";
// import Distributors from "./Adminstrator/Distributors/Distributors";
// import IntegrateSupportTickets from "./Service/IntegrateSupportTickets/IntegrateSupportTickets";
// import SupportTickets from "./Service/SupportTickets/SupportTickets";
// import AccountView from "./masters/accounts/AccountMasterView";
// import UserMaster from "./masters/usermaster/UserMaster";
// import SuspensionApproval from "./Service/SuspensionApproval/SuspensionApproval";
// import PurchaseOrder from "./Finance/PurchaseOrder/PurchaseOrder";
// import Opportunities from "./crm/opportinities/Opportunity";
// import OpportunityView from "./crm/opportinities/OpportunityView";
// import IncomingPayments from "./Finance/IncomingPayments/IncomingPayments";
// import DatapointSearch from "./crm/leads/Lead";
// import PurchaseOrderFollow from "./Finance/PurchaseOrderFollow-Up/PurchaseOrderFollow";
// import AROutstandingAndFollowup from "./Finance/AROutstanding&Follow-up/AROutstanding&Follow-up";
// import Invoices from "./Finance/Invoices/Invoices";
// import LeadView from "./crm/leads/LeadView";
// import POCView from "./crm/MyPOCs/POCView";
// import ReleaseOrders from "./Delivery/ReleaseOrders/ReleaseOrders";
// import DeliveryApproval from "./Service/DeliveryApproval/DeliveryApproval";
// import OrderExecutive from "./Delivery/OrderExecutive/OrderExecutive";
// import OrderExecutiveRenewal from "./Delivery/OrderExecutiveRenewal/OrderExecutiveRenewal";
// import Product from "./masters/product/Product";
// import RenewalTargets from "./Operations/RenewalTargets/RenewalTargets";
// import SalesOrderOperation from "./Operations/SalesOrderOperation/SalesOrderOperation";
// import Suspensions from "./Operations/Suspensions/Suspensions";
// import ProductMasterView from "./masters/product/ProductMasterView";
// import Quotation from "./crm/Quotation/Quotation";
// import QuotationView from "./crm/Quotation/QuotationView";
// import QuotationAnalysis from "./MIS/QuotationAnalysis";
// import ApproveRenewal from "./Operations/Approve Renewal/ApproveRenewal";
// import ApproveSalesOrder from "./Operations/ApproveSalesOrder/ApproveSalesOrder";
// import QuotationLostAnalysis from "./MIS/QuotationLostAnalysis";
// import SalesOrder from "./crm/SalesOrder/SalesOrder";
// import MYActivities from "./Delivery/MYActivities/MYActivities";
// import DeliveryTeamDashboard from "./Delivery/DeliveryTeamDashboard/DeliveryTeamDashboard";
// import Contact from "./Operations/Contracts(New,Renewal,Upgrade)/Contacts";
// import CustomerDispute from "./Operations/CustomerDisputes/CustomerDispues";
// import ListPOCForApprovingAndScheduling from "./crm/ListPOCForApprovingAndScheduling/ListPOCForApprovingAndScheduling";
// import RenewalFollowup from "./Operations/RenewalFollow-up/RenewalFollow-up";
// import MyPOCs from "./crm/MyPOCs/MyPOCs";
// import SOMasterView from "./crm/SalesOrder/SOMasterView";
// import OperationsDashboard from "./Operations/OperationsDashboard/OperationsDashboard";
// import CRMTest from "./crm/CRMTest";
// import Activities from "./crm/Activities";
//import MessageCenter from "./crm/MessageCenter";
// import MessageCenter from "./crm/MessageCenter/MessageCenter";
// import CustomerCompaints from "./crm_service/CustomerCompaints";
// import Sales from "./Sales/Sales";
//import DeliveryChallan from "./Sales/DeliveryChallan";
// import DeliveryChallan from "./Sales/DeliveryChallan/DeliveryChallan";
// import DCMasterView from "./Sales/DeliveryChallan/DCMasterView";
// import DispatchManagement from "./Sales/DispatchManagement";
// import Invoice from "./Sales/Invoice";
// import SalesAnalysis from "./Sales/SalesAnalysis/SalesAnalysis";
// import CountryWise from "./Sales/SalesAnalysis/CountryWise";
// import ProductWise from "./Sales/SalesAnalysis/ProductWise";
// import SalesTeamWise from "./Sales/SalesAnalysis/SalesTeamWise";
// import FGInwardToWarehouse from "./inventory/FGInwardToWarehouse";
// import StockInward from "./inventory/StockInward";
// import StockLedger from "./inventory/StockLedger";
// import StockOutward from "./inventory/StockOutward";
// import StockStatus from "./inventory/StockStatus";
// import SalesTargetvsActual from "./crm/SalesTargetvsActual/SalesTargetvsActual";
// import MyLead from "./crm/leads/MyLead";
// import ListMyDatapoint from "./crm/leads/MyDatapoint";
// import POCTestListDtls from "./masters/DocTestListMaster/POCTestListDtls";

const FormList = ({ name }) => {
  const classes = useStyles();
  switch (name) {
    case "Expenses":
      if (Session.get("UserType") == "Manager" || Session.get("UserType") == "CFO") {
        return (
          <div>
            <div className={classes.header}>{name}</div>
            <div className={classes.content}>
              <ExpenseApproval />
            </div>
          </div>
        );
      }
      else if (Session.get("UserType") == "Manager") {
        return (
          <div>
            <div className={classes.header}>{name}</div>
            <div className={classes.content}>
              <SeniorExpenseApproval />
            </div>
          </div>
        );
      }
      else if (Session.get("UserType") == "Admin"  ) {
        return (
          <div>
            {/* <div className={classes.header}>{name}</div> */}
            <div className={classes.header}>{name}</div>
            <div className={classes.content}></div>
            <div className={classes.contentViewDash}>
              <ExpenseApproval />
            </div>
          </div>
        );
      }
       else if (Session.get("UserType") == "Employee") {
        return (
          <div>
            {/* <div className={classes.header}>{name}</div> */}
            <div className={classes.contentViewDash}>
              <TravelRequest />
            </div>
          </div>
        );
      }
      else {
        return (
          <div>
            <div className={classes.header}>{name}</div>
            <div className={classes.contentViewDash}>
              <Home />
            </div>
          </div>
        );
      }
    case "Home Page":
      if (Session.get("UserType") == "Manager" || Session.get("UserType") == "CFO" ) {
        return (
          <div>
            <div className={classes.header}>{name}</div>
            <div className={classes.content}>
              <TravelRequestApproval />
            </div>
          </div>
        ); 
      } 
      else if (Session.get("UserType") == "Employee") {
        return (
          <div>
            {/* <div className={classes.header}>{name}</div> */}
            <div className={classes.contentViewDash}>
              <TravelRequest />
            </div>
          </div>
        );
      }
      else {
        return (
          <div>
            <div className={classes.header}>{name}</div>
            <div className={classes.contentViewDash}>
              <Home />
            </div>
          </div>
        );
      }
    case "Branch Master":
      return (
        <div>
          {/* <div className={classes.header}>{name}</div> */}
          <div className={classes.content}>
            <BranchMaster />
          </div>
        </div>
      );
    case "Travel Request Report":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <TravelRequestReport />
          </div>
        </div>
      );
    case "Expense Claimed Report":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <ExpenseClaimedReport />
          </div>
        </div>
      );
    case "Employee":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <EmployeeMaster />
          </div>
        </div>
      );
    case "Primary Masters":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <PrimaryMaster />
          </div>
        </div>
      );
    case "Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <PrimaryMaster />
          </div>
        </div>
      );
    case "Product Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <CreateProductMaster />
          </div>
        </div>
      );
    case "Symptom Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <CreateSymptomMaster />
          </div>
        </div>
      );
    case "Expense Sheet List":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <ExpenseSheetList />
          </div>
        </div>
      );
      case "Expense Report":
        return (
          <div>
            <div className={classes.header}>{name}</div>
            <div className={classes.content}>
              <ExpenseReport />
            </div>
          </div>
        );
    
   case "Senior Account Report":
    if (Session.get("UserType") == "Admin" || Session.get("UserType") == "Manager") {
   return (
    
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SeniorAccountReport />
          </div>
        </div>
      );
    }
    case "Senior Expense Report":
    if (Session.get("UserType") == "Admin" || Session.get("UserType") == "Manager") {
   return (
    
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SeniorExpenseReport />
          </div>
        </div>
      );
    }


    case "User Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <UserMaster />
          </div>
        </div>
      );
    case "Work Plan Approval":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <TravelRequestApproval />
          </div>
        </div>
      );
    case "Expense Approval":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <ExpenseApproval />
          </div>
        </div>
      );

    case "CFO Approval":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <PendingManagerApproval />
          </div>
        </div>
      );
    case "Travel Request":
      return (
        <div>
          {/* <div className={classes.header}>{name}</div> */}
          <div className={classes.contentViewDash}>
            <TravelRequest />
          </div>
        </div>
      );
      case "Senior Expense Approval":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SeniorExpenseApproval />
          </div>
        </div>
      );
    // case "Dashboard IS":
    //   return (
    //     <div>
    //       {/* <div className={classes.header}>{name}</div> */}
    //       <div className={classes.contentViewDash}>
    //         <DashboardIS />
    //       </div>
    //     </div>
    //   );
    // case "Dashboard Sales":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DashboardSales />
    //       </div>
    //     </div>
    //   );
    // case "Dashboard Pre-Sales":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DashboardPreSales />
    //       </div>
    //     </div>
    //   );
    // case "Import Datapoints":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <ImportDataPoints />
    //       </div>
    //     </div>
    //   );
    // case "Assign Lead To Sales Executive":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <AssignLeadToSalesExecutive />
    //       </div>
    //     </div>
    //   );
    // case "Nurture Basket":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <AllocateDatapointsFromNurtureBasketToISR />
    //       </div>
    //     </div>
    //   );
    // case "My Opportunities":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <MyOpportunities />
    //       </div>
    //     </div>
    //   );
    // case "Customer Search":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Account />
    //       </div>
    //     </div>
    //   );
    // case "My Customer":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <MyCustomer />
    //       </div>
    //     </div>
    //   );
    // case "User Master":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <UserMaster />
    //       </div>
    //     </div>
    //   );
    // case "Account View":
    //   return (
    //     <div className={classes.contentView}>
    //       <AccountView />
    //     </div>
    //   );
    // case "Lead View":
    //   return (
    //     <div className={classes.contentView}>
    //       <LeadView />
    //     </div>
    //   );
    // case "POC View":
    //   return (
    //     <div className={classes.contentView}>
    //       <POCView />
    //     </div>
    //   );
    // case "Datapoints Search":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DatapointSearch />
    //       </div>
    //     </div>
    //   );
    //   case "My Datapoints":
    //     return (
    //       <div>
    //         <div className={classes.header}>{name}</div>
    //         <div className={classes.content}>
    //           <ListMyDatapoint />
    //         </div>
    //       </div>
    //     );
    //     case "My Leads":
    //       return (
    //         <div>
    //           <div className={classes.header}>{name}</div>
    //           <div className={classes.content}>
    //             <MyLead />
    //           </div>
    //         </div>
    //       );
    //   case "Allocate Datapoint to ISR":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <AllocateLeadsToISR />
    //       </div>
    //     </div>
    //   );
    // // case "ImportDataPoints":
    // //   return (
    // //     <div className={classes.contentView}>
    // //       <ImportDataPoints />
    // //     </div>
    // //   );
    // case "Product Master":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Product />
    //       </div>
    //     </div>
    //   );
    // case "Product View":
    //   return (
    //     <div className={classes.contentView}>
    //       <ProductMasterView />
    //     </div>
    //   );
    // case "Opportunity Search":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Opportunities />
    //       </div>
    //     </div>
    //   );
    // case "List of Quotation to Apply Discount":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Quotation />
    //       </div>
    //     </div>
    //   );
    // case "Quotation Analysis":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <QuotationAnalysis />
    //       </div>
    //     </div>
    //   );
    // case "Lost Quotation Analysis":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <QuotationLostAnalysis />
    //       </div>
    //     </div>
    //   );
    // case "Sales Order":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <SalesOrder />
    //       </div>
    //     </div>
    //   );
    // case "List Of POC for Approving & Scheduling":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <ListPOCForApprovingAndScheduling />
    //       </div>
    //     </div>
    //   );
    // case "My POCs":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <MyPOCs />
    //       </div>
    //     </div>
    //   );
    // case "Poc Test List Master":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DocTestListMaster />
    //       </div>
    //     </div>
    //   );
    // case "Operations Dashboard":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <OperationsDashboard />
    //       </div>
    //     </div>
    //   );
    // case "Renewal Follow-up":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <RenewalFollowup />
    //       </div>
    //     </div>
    //   );
    // case "Approve Renewal":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <ApproveRenewal />
    //       </div>
    //     </div>
    //   );
    // case "Approve SalesOrder":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <ApproveSalesOrder />
    //       </div>
    //     </div>
    //   );
    // case "Contact":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Contact />
    //       </div>
    //     </div>
    //   );
    // case "Customer Dispute":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <CustomerDispute />
    //       </div>
    //     </div>
    //   );
    // // case "Renewal":
    // //   return (
    // //     <div>
    // //       <div className={classes.header}>{name}</div>
    // //       <div className={classes.content}>
    // //         <Renewal />
    // //       </div>
    // //     </div>
    // //   );
    // case "Renewal Targets":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <RenewalTargets />
    //       </div>
    //     </div>
    //   );
    //   case "Suspensions":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Suspensions />
    //       </div>
    //     </div>
    //   );
    // case "DeliveryTeam Dashboard":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DeliveryTeamDashboard />
    //       </div>
    //     </div>
    //   );
    // case "OrderExecutive Renewal":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <OrderExecutiveRenewal />
    //       </div>
    //     </div>
    //   );
    // case "Order Executive":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <OrderExecutive />
    //       </div>
    //     </div>
    //   );
    // case "Release Orders":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <ReleaseOrders />
    //       </div>
    //     </div>
    //   );
    //   case "Sales Order Operation":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <SalesOrderOperation />
    //       </div>
    //     </div>
    //   );
    // case "MY Activities":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <MYActivities />
    //       </div>
    //     </div>
    //   );
    // case "Delivery Approval":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DeliveryApproval />
    //       </div>
    //     </div>
    //   );
    // case "Integrate Support Tickets":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <IntegrateSupportTickets />
    //       </div>
    //     </div>
    //   );
    // case "Support Tickets":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <SupportTickets />
    //       </div>
    //     </div>
    //   );
    // case "Suspension Approval":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <SuspensionApproval />
    //       </div>
    //     </div>
    //   );
    // case "Purchase Order":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <PurchaseOrder />
    //       </div>
    //     </div>
    //   );
    // case "Purchase Order Follow":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <PurchaseOrderFollow />
    //       </div>
    //     </div>
    //   );
    // case "Release Orders":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <ReleaseOrders />
    //       </div>
    //     </div>
    //   );
    //   case "Invoices":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Invoices />
    //       </div>
    //     </div>
    //   );
    //   case "Incoming Payments":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <IncomingPayments />
    //       </div>
    //     </div>
    //   );
    //   case "AR Outstanding And Followup":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <AROutstandingAndFollowup />
    //       </div>
    //     </div>
    //   );
    //   case "Bonus Managment":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <BonusManagment />
    //       </div>
    //     </div>
    //   );
    //   case "Customer":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Customer />
    //       </div>
    //     </div>
    //   );
    //   case "Distributors":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Distributors />
    //       </div>
    //     </div>
    //   );
    //   case "Incentive Managment":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <IncentiveManagment />
    //       </div>
    //     </div>
    //   );case "Milestone Templates":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <MilestoneTemplates />
    //       </div>
    //     </div>
    //   );
    //     case "PriceList":
    //     return (
    //       <div>
    //         <div className={classes.header}>{name}</div>
    //         <div className={classes.content}>
    //           <PriceList />
    //         </div>
    //       </div>
    //     );
    //     case "Partners":
    //     return (
    //       <div>
    //         <div className={classes.header}>{name}</div>
    //         <div className={classes.content}>
    //           <Partners />
    //         </div>
    //       </div>
    //     );
    //     case "PrimaryMaster Administrator":
    //     return (
    //       <div>
    //         <div className={classes.header}>{name}</div>
    //         <div className={classes.content}>
    //           <PrimaryMasterAdministrator />
    //         </div>
    //       </div>
    //     );
    //     case "Product Master SKU":
    //       return (
    //         <div>
    //           <div className={classes.header}>{name}</div>
    //           <div className={classes.content}>
    //             <ProductMasterSKU />
    //           </div>
    //         </div>
    //       );
    //     case "Renewal Target":
    //     return (
    //       <div>
    //         <div className={classes.header}>{name}</div>
    //         <div className={classes.content}>
    //           <RenewalTarget />
    //         </div>
    //       </div>
    //     );
    //     case "Sales Target":
    //     return (
    //       <div>
    //         <div className={classes.header}>{name}</div>
    //         <div className={classes.content}>
    //           <SalesTarget />
    //         </div>
    //       </div>
    //     );
    //     case "UserMaster And Right":
    //       return (
    //         <div>
    //           <div className={classes.header}>{name}</div>
    //           <div className={classes.content}>
    //             <UserMasterAndRight />
    //           </div>
    //         </div>
    //       );
    //       case "Vendors":
    //         return (
    //           <div>
    //             <div className={classes.header}>{name}</div>
    //             <div className={classes.content}>
    //               <Vendors />
    //             </div>
    //           </div>
    //         );

    // case "CRMTest":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <CRMTest />
    //       </div>
    //     </div>
    //   );
    // case "Activities":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Activities />
    //       </div>
    //     </div>
    //   );
    // case "Customer Compaints":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <CustomerCompaints />
    //       </div>
    //     </div>
    //   );
    // case "Message Center":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <MessageCenter />
    //       </div>
    //     </div>
    //   );
    // case "Sales":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Sales />
    //       </div>
    //     </div>
    //   );
    // case "Delivery Challan":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DeliveryChallan />
    //       </div>
    //     </div>
    //   );
    // case "Dispatch Management":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <DispatchManagement />
    //       </div>
    //     </div>
    //   );
    // case "Invoice":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Invoice />
    //       </div>
    //     </div>
    //   );
    // case "Sales Analysis":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <SalesAnalysis />
    //       </div>
    //     </div>
    //   );
    // case "Sales Analysis Country Wise":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <CountryWise />
    //       </div>
    //     </div>
    //   );
    // case "Sales Analysis Product Wise":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <ProductWise />
    //       </div>
    //     </div>
    //   );
    // case "Sales Analysis Sales Team Wise":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <SalesTeamWise />
    //       </div>
    //     </div>
    //   );
    // case "Opportunity View":
    //   return (
    //     <div className={classes.contentView}>
    //       <OpportunityView />
    //     </div>
    //   );
    // case "Quotation View":
    //   return (
    //     <div className={classes.contentView}>
    //       <QuotationView />
    //     </div>
    //   );
    // case "Sales Order View":
    //   return (
    //     <div className={classes.contentView}>
    //       <SOMasterView />
    //     </div>
    //   );
    // case "Delivery Challan View":
    //   return (
    //     <div className={classes.contentView}>
    //       <DCMasterView />
    //     </div>
    //   );
    // case "FG Inward To Warehouse":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <FGInwardToWarehouse />
    //       </div>
    //     </div>
    //   );
    // case "Stock Inward":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <StockInward />
    //       </div>
    //     </div>
    //   );
    // case "Stock Ledger":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <StockLedger />
    //       </div>
    //     </div>
    //   );
    // case "Stock Outward":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <StockOutward />
    //       </div>
    //     </div>
    //   );
    // case "Stock Status":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <StockStatus />
    //       </div>
    //     </div>
    //   );
    // case "Logistics":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Home />
    //       </div>
    //     </div>
    //   );
    // case "Inventory":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <Home />
    //       </div>
    //     </div>
    //   );
    //   case "Sales Target vs Actual":
    //     return (
    //       <div>
    //         <div className={classes.header}>{name}</div>
    //         <div className={classes.content}>
    //           <SalesTargetvsActual />
    //         </div>
    //       </div>
    //     );
    //   default:
    //     return <div>Form Not Found Page to be displayed here</div>;
  }
};

const useStyles = makeStyles((theme) => ({
  html: {
    height: "100%",
  },
  body: {
    height: "100%",
    display: "flex",
  },
  header: {
    // background: theme.palette.tertiary.gradient,
    color: "black",
    height: "2rem",
    paddingLeft: "1rem",
    fontSize: "1.3rem",
    marginTop: "5rem",
    marginBottom: "0.5rem",
    borderRadius: "0.5rem",
    position: "absolute",
    maxWidth: "95%",
    minWidth: "91%",
    flexGrow: 1,
  },
  content: {
    position: "absolute",
    marginTop: "7.5rem",
    minWidth: "91%",
    maxWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    flexGrow: 1,
  },
  contentView: {
    position: "absolute",
    marginTop: "0rem",
    minWidth: "91%",
    maxWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    // flexGrow: 1,
  },
  contentViewDash: {
    position: "absolute",
    marginTop: "5rem",
    minWidth: "91%",
    maxWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    // flexGrow: 1,
  },
}));

export default FormList;
